function formScreen({ id, title, terminal = false, children }) {
  return {
    id,
    title,
    terminal,
    success: terminal,
    data: {},
    layout: {
      type: "SingleColumnLayout",
      children: [
        {
          type: "Form",
          name: "flow_form",
          children,
        },
      ],
    },
  };
}

function navigateFooter(label, nextScreenId) {
  return {
    type: "Footer",
    label,
    "on-click-action": {
      name: "navigate",
      next: { type: "screen", name: nextScreenId },
      payload: {},
    },
  };
}

function completeFooter(label = "Submit") {
  return {
    type: "Footer",
    label,
    "on-click-action": { name: "complete", payload: {} },
  };
}

function flow(screens) {
  const routing_model = {};
  screens.forEach((screen, index) => {
    routing_model[screen.id] = screens[index + 1] ? [screens[index + 1].id] : [];
  });
  return { version: "7.3", routing_model, screens };
}

const OPTIONS = {
  services: [
    { id: "consult", title: "Consultation" },
    { id: "demo", title: "Product demo" },
    { id: "support", title: "Support" },
  ],
  interests: [
    { id: "product", title: "Product" },
    { id: "service", title: "Service" },
    { id: "partnership", title: "Partnership" },
    { id: "other", title: "Other" },
  ],
  ratings: [
    { id: "5", title: "Excellent" },
    { id: "4", title: "Good" },
    { id: "3", title: "Average" },
    { id: "2", title: "Poor" },
    { id: "1", title: "Very poor" },
  ],
  topics: [
    { id: "sales", title: "Sales" },
    { id: "billing", title: "Billing" },
    { id: "technical", title: "Technical" },
    { id: "other", title: "Other" },
  ],
  issues: [
    { id: "order", title: "Order issue" },
    { id: "account", title: "Account issue" },
    { id: "product", title: "Product question" },
    { id: "other", title: "Something else" },
  ],
};

/** Starter templates that match WhatsApp Manager → Create Flow. */
export const WHATSAPP_MANAGER_TEMPLATES = [
  {
    id: "blank",
    name: "Blank",
    description: "Start with an empty screen and build your own Flow.",
    categories: ["OTHER"],
    suggestedName: "Untitled Flow",
    flowJson: flow([
      formScreen({
        id: "WELCOME_SCREEN",
        title: "Welcome",
        terminal: true,
        children: [
          { type: "TextHeading", text: "Hello World" },
          completeFooter("Complete"),
        ],
      }),
    ]),
  },
  {
    id: "lead_generation",
    name: "Lead generation",
    description: "Collect name, contact details, and interest.",
    categories: ["LEAD_GENERATION"],
    suggestedName: "Lead generation",
    flowJson: flow([
      formScreen({
        id: "LEAD",
        title: "Get in touch",
        terminal: true,
        children: [
          { type: "TextHeading", text: "Tell us about you" },
          {
            type: "TextBody",
            text: "Share a few details and our team will contact you.",
          },
          {
            type: "TextInput",
            name: "full_name",
            label: "Full name",
            required: true,
            "input-type": "text",
          },
          {
            type: "TextInput",
            name: "phone",
            label: "Phone",
            required: true,
            "input-type": "phone",
          },
          {
            type: "TextInput",
            name: "email",
            label: "Email",
            required: false,
            "input-type": "email",
          },
          {
            type: "Dropdown",
            name: "interest",
            label: "I'm interested in",
            required: true,
            "data-source": OPTIONS.interests,
          },
          completeFooter("Submit"),
        ],
      }),
    ]),
  },
  {
    id: "appointment_booking",
    name: "Book an appointment",
    description: "Choose a service and date, then share contact details.",
    categories: ["APPOINTMENT_BOOKING"],
    suggestedName: "Book an appointment",
    flowJson: flow([
      formScreen({
        id: "APPOINTMENT",
        title: "Appointment",
        children: [
          { type: "TextHeading", text: "Book an appointment" },
          {
            type: "Dropdown",
            name: "service",
            label: "Service",
            required: true,
            "data-source": OPTIONS.services,
          },
          {
            type: "DatePicker",
            name: "date",
            label: "Preferred date",
            required: true,
          },
          navigateFooter("Continue", "DETAILS"),
        ],
      }),
      formScreen({
        id: "DETAILS",
        title: "Your details",
        terminal: true,
        children: [
          { type: "TextHeading", text: "How can we reach you?" },
          {
            type: "TextInput",
            name: "full_name",
            label: "Full name",
            required: true,
            "input-type": "text",
          },
          {
            type: "TextInput",
            name: "phone",
            label: "Phone",
            required: true,
            "input-type": "phone",
          },
          completeFooter("Book now"),
        ],
      }),
    ]),
  },
  {
    id: "sign_up",
    name: "Sign up",
    description: "Create a profile with name, email, and opt-in.",
    categories: ["SIGN_UP"],
    suggestedName: "Sign up",
    flowJson: flow([
      formScreen({
        id: "SIGN_UP",
        title: "Sign up",
        terminal: true,
        children: [
          { type: "TextHeading", text: "Create your account" },
          {
            type: "TextInput",
            name: "full_name",
            label: "Full name",
            required: true,
            "input-type": "text",
          },
          {
            type: "TextInput",
            name: "email",
            label: "Email",
            required: true,
            "input-type": "email",
          },
          {
            type: "TextInput",
            name: "phone",
            label: "Phone",
            required: true,
            "input-type": "phone",
          },
          {
            type: "OptIn",
            name: "opt_in",
            label: "I agree to be contacted on WhatsApp",
            required: true,
          },
          completeFooter("Sign up"),
        ],
      }),
    ]),
  },
  {
    id: "sign_in",
    name: "Sign in",
    description: "Ask for a phone or email to sign the user in.",
    categories: ["SIGN_IN"],
    suggestedName: "Sign in",
    flowJson: flow([
      formScreen({
        id: "SIGN_IN",
        title: "Sign in",
        terminal: true,
        children: [
          { type: "TextHeading", text: "Welcome back" },
          {
            type: "TextInput",
            name: "identifier",
            label: "Email or phone",
            required: true,
            "input-type": "text",
          },
          completeFooter("Continue"),
        ],
      }),
    ]),
  },
  {
    id: "contact_us",
    name: "Contact us",
    description: "Let customers send a topic and message.",
    categories: ["CONTACT_US"],
    suggestedName: "Contact us",
    flowJson: flow([
      formScreen({
        id: "CONTACT",
        title: "Contact us",
        terminal: true,
        children: [
          { type: "TextHeading", text: "How can we help?" },
          {
            type: "RadioButtonsGroup",
            name: "topic",
            label: "Topic",
            required: true,
            "data-source": OPTIONS.topics,
          },
          {
            type: "TextArea",
            name: "message",
            label: "Message",
            required: true,
          },
          {
            type: "TextInput",
            name: "full_name",
            label: "Your name",
            required: true,
            "input-type": "text",
          },
          completeFooter("Send"),
        ],
      }),
    ]),
  },
  {
    id: "customer_support",
    name: "Get support",
    description: "Capture the issue type and a short description.",
    categories: ["CUSTOMER_SUPPORT"],
    suggestedName: "Get support",
    flowJson: flow([
      formScreen({
        id: "SUPPORT",
        title: "Support",
        terminal: true,
        children: [
          { type: "TextHeading", text: "We're here to help" },
          {
            type: "Dropdown",
            name: "issue_type",
            label: "Issue type",
            required: true,
            "data-source": OPTIONS.issues,
          },
          {
            type: "TextArea",
            name: "details",
            label: "Describe the issue",
            required: true,
          },
          {
            type: "TextInput",
            name: "order_id",
            label: "Order / ticket ID (optional)",
            required: false,
            "input-type": "text",
          },
          completeFooter("Submit request"),
        ],
      }),
    ]),
  },
  {
    id: "survey",
    name: "Collect feedback",
    description: "Ask for a rating and optional comments.",
    categories: ["SURVEY"],
    suggestedName: "Collect feedback",
    flowJson: flow([
      formScreen({
        id: "FEEDBACK",
        title: "Feedback",
        terminal: true,
        children: [
          { type: "TextHeading", text: "How was your experience?" },
          {
            type: "RadioButtonsGroup",
            name: "rating",
            label: "Rating",
            required: true,
            "data-source": OPTIONS.ratings,
          },
          {
            type: "TextArea",
            name: "comments",
            label: "Anything else we should know?",
            required: false,
          },
          completeFooter("Send feedback"),
        ],
      }),
    ]),
  },
];

export function stringifyFlowTemplate(template) {
  return JSON.stringify(template.flowJson, null, 2);
}

export function flowRecordToTemplate(flow, source = "manager") {
  const json = flow?.flow_json || flow?.flowJson || flow?.json || null;
  return {
    id: `${source}-${flow.id || flow._id}`,
    metaFlowId: flow.id || flow._id,
    name: flow.name || "Untitled flow",
    description: `${flow.status || "DRAFT"}${(flow.categories || []).length ? ` • ${(flow.categories || []).join(", ")}` : ""}`,
    categories:
      Array.isArray(flow.categories) && flow.categories.length
        ? flow.categories
        : ["OTHER"],
    suggestedName: `${flow.name || "Flow"} copy`,
    flowJson: json,
    source,
  };
}
